import { Card, Flex, Select, Typography } from "antd";
import styled from "styled-components";

import FlexContainer from "@/components/FlexContainer";

const { Link } = Typography;

export const StyledScheduleFormWrapper = styled.div`
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    width: 100%;
    padding: 16px;
    background-color: ${(props) => props.theme.secondaryBackgroundColor};
`;

export const RouteItem = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 6px;
    width: 100%;
    margin-bottom: 8px;
    padding: 16px;
    && {
        background-color: ${(props) => props.theme.secondaryBackgroundColor};
        border: 1px solid ${(props) => props.theme.secondaryBorderColor};
    }
`;

export const InfoContainerList = styled(Card)`
    gap: 16px;
    border-radius: 10px;
    border: none;
    width: 100%;
`;

export const InfoContainerListTopBlock = styled(FlexContainer)`
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #313131;
    padding-bottom: 16px;
    gap: 12px;
`;

export const InfoContainerListCenterBlock = styled(FlexContainer)`
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #313131;
    padding: 16px 0;
    gap: 12px;
`;

export const InfoContainerListBottomBlock = styled(FlexContainer)`
    align-items: center;
    justify-content: space-between;
    padding-top: 16px;
    gap: 12px;
`;

export const UserInfoTitle = styled(Typography)`
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
    text-align: left;
`;

export const UserInfoDescriptionLink = styled(Link)`
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    text-align: left;
    && {
        color: ${(props) => props.theme.secondaryTypographyColor}!important;
    }
`;

export const UserInfoDescriptionText = styled(Typography)`
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    text-align: left;
    && {
        color: ${(props) => props.theme.secondaryTypographyColor};
    }
`;

export const StyledSelect = styled(Select)`
    height: 47px;
    border-radius: 4px;
    border: initial;
    width: 100%;

    .ant-select-selector {
        font-size: 14px;
    }
`;

export const StyledScrollContainer = styled(Flex)`
    overflow-y: auto;
    min-height: 0;
    height: 100%;
    padding: 16px;
    padding-bottom: 0;
`;

export const StyledControlsContainer = styled.div`
    position: relative;
    margin-top: auto;
    padding: 16px;
    flex-shrink: 1;
`;
